module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"action-zone-visibility":"Статус","vehicle-access-geozones":"Геозоны доступа ТС"}}')
  delete Component.options._Ctor
}
